import React, { useEffect, useMemo, useState } from "react";
import PopupFooter from ".";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import { Pagination, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "../../../../../utils/hooks";
import bgButtonActive from "../../../../../assets/images/Mini-Game/bg-tab-active-popup.png";
import bgButton from "../../../../../assets/images/Mini-Game/bg-tab-popup.png";
import { useDispatch, useSelector } from "react-redux";
import {
  curStateAccount,
  curStateMiniGame,
} from "../../../../../Redux/selector";
import { getDataSpinHistoryMiniGame } from "../../../../../Redux/futures/mini-game/action";
import _ from "lodash";
import { ID_GIFT_PLAY_LOTO } from "../../../../../helper/const";
import iconGoogluck from "../../../../../assets/images/Mini-Game/popup-good-luck-icon.png";
import iconAddSpin from "../../../../../assets/images/Mini-Game/reel-add-slot.png";
import iconBid from "../../../../../assets/images/Mini-Game/reel-bid.png";
import moment from "moment";

const PARAM_HISTORY = {
  all: 0,
  yourHistory: 1,
};

const LIMIT_DATA = 10;
export default function PopupActivityHis({
  isShowPopupHistory,
  setIsShowPopupHistory,
}) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(`(max-width: 486px)`);
  const [isLoader, setIsLoader] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const selectorAccount = useSelector(curStateAccount);
  const statusMiniGame = useSelector(curStateMiniGame)?.configMiniGame;
  const dataActivityHis =
    useSelector(curStateMiniGame).dataSpinHistoryMini || {};

  const isLogin = !!selectorAccount?.userInfo;
  const [tabActive, setTabActive] = useState(PARAM_HISTORY.all);
  const dispatch = useDispatch();
  const dataTab = [
    {
      id: PARAM_HISTORY.all,
      content: t("mini_game.pop_up_activity_history.all_histories"),
    },
    ...(isLogin
      ? [
        {
          id: PARAM_HISTORY.yourHistory,
          content: t("mini_game.pop_up_activity_history.your_histories"),
        },
      ]
      : []), // hien thi tab Your histories khi da dang nhap
  ];

  const handleGetDataWinner = async () => {
    setIsLoader(true);
    setTimeout(() => {
      setIsLoader(false);
    }, [400]);
  };

  useEffect(() => {
    handleGetDataWinner();
    const data = {
      my_history: tabActive,
      limit: LIMIT_DATA,
      page: currentPage,
      minigame_id: statusMiniGame?.minigame?.id,
    };
    dispatch(getDataSpinHistoryMiniGame(data));
  }, [tabActive, currentPage]);

  const highlightRow = (record) => {
    return +record.its_me === 1 ? "highlight-row" : "";
  };

  let dataLoader = [];
  for (let i = 0; i < 10; i++) {
    dataLoader = [
      ...dataLoader,
      {
        key: `id_loader_${i}`,
        id: `id_loader_${i}`,
        isdn: "",
        award_id: "",
        num: 0,
        take_time: "",
        name: "",
        image: {
          img: "",
          name: "",
        },
        time: {
          day: "",
          house: "",
        },
      },
    ];
  }

  const formatData = useMemo(() => {
    if (_.isEmpty(dataActivityHis?.resultLast)) {
      return [];
    }

    const handleGetImg = (awardId) => {
      switch (awardId) {
        case ID_GIFT_PLAY_LOTO.good_luck:
          return iconGoogluck;
        case ID_GIFT_PLAY_LOTO.add_spin:
          return iconAddSpin;
        case ID_GIFT_PLAY_LOTO.bid_free:
          return iconBid;
        default:
          break;
      }
    };

    const newData = dataActivityHis.resultLast.map((item = {}) => {
      return {
        ...item,
        spin_award_id: item.award_id,
        num: item.award_value,
        take_time: item.spin_time,
        name: item.award_name,
        image: {
          img: item.image || handleGetImg(item.spin_award_id),
          name: item.name ? `${item.award_name || ""} - Piece ${item.name}` : `${+item.award_value || ""} ${item.award_name}`,
        },
        time: {
          day: moment(item.spin_time).local().format("YYYY-MM-DD"),
          house: moment(item.spin_time).local().format("HH:mm:ss"),
        },
      };
    });
    return newData || [];
  }, [dataActivityHis.resultLast]);

  return (
    <div className="popup-minigame__2025 popup-mini-activity-his">
      <PopupFooter
        isOpen={isShowPopupHistory}
        onClose={() => setIsShowPopupHistory(false)}
        className={"popup-activity-history-mini"}
      >
        <>
          <div className="header-mini-popup-rule">
            <img src={bgHeader} alt="" className="img-rule-mini" />
            <div className="content-rule-mini">{t("mini_game.pop_up_activity_history.title")}</div>
          </div>

          {/* <div className="mini-tab-popup">
            {dataTab.map((item) => (
              <div
                key={item.id}
                className={`position-relative tab-mini-popup ${
                  item.id === tabActive ? "tab-popup-active" : ""
                }`}
                onClick={() => {setTabActive(item.id); setCurrentPage(1)}}
              >
                <img
                  src={item.id === tabActive ? bgButtonActive : bgButton}
                  alt=""
                />
                <div className="tab-popup__content">{item.content}</div>
              </div>
            ))}
          </div> */}

          <Table
            className="table-winner"
            dataSource={isLoader ? dataLoader : formatData || []}
            pagination={false}
            scroll={{
              y: 365,
            }}
          // rowClassName={highlightRow}
          >
            <Table.Column
              title={t("event_thingyan.pop_up.prize")}
              dataIndex="image"
              key="image"
              render={(data) => {
                return (
                  <div
                    className="column-prize"
                    style={{
                      minHeight: `${isLoader ? "100px" : ""}`,
                      textAlign: "center",
                    }}
                  >
                    {data.img ? (
                      <img src={data.img} alt="prize" height={40} className="h-[40px]" style={{ margin: "0 auto" }} />
                    ) : null}
                    <p className="prize-name">{data.name}</p>
                  </div>
                );
              }}
            />
            <Table.Column
              title={t("event_thingyan.pop_up.time")}
              dataIndex="time"
              key="time"
              render={(data) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      columnGap: 4,
                    }}
                  >
                    <span style={{ whiteSpace: "nowrap" }}>{data.day}</span>
                    <span style={{ whiteSpace: "nowrap" }}>{data.house}</span>
                  </div>
                );
              }}
            />
            {/* <Table.Column
              title={t("event_thingyan.pop_up.isdn")}
              dataIndex="isdn"
              key="isdn"
            /> */}
            <Table.Column
              title={t("action")}
              dataIndex="action"
              key="action"
              render={(action) => {
                if (!action || typeof action !== "string") return action;
                const lower = action.toLowerCase();
                return lower.charAt(0).toUpperCase() + lower.slice(1);
              }}
            />
          </Table>

          <div className="pagination-popup-his__mini-game">
            <Pagination
              current={currentPage}
              pageSize={10}
              total={dataActivityHis.total}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
              itemRender={(page, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                      className="action-table-mini-game"
                    >
                      ←{" "}
                      <span className="action-table-mini-game-content">
                        {t("mini_game.pop_up_activity_history.prev")}
                      </span>
                    </span>
                  );
                }
                if (type === "next") {
                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                      className="action-table-mini-game"
                    >
                      <span className="action-table-mini-game-content">
                        {t("mini_game.pop_up_activity_history.next")}
                      </span>{" "}
                      →
                    </span>
                  );
                }
                return originalElement;
              }}
            />
          </div>
        </>
      </PopupFooter>
    </div>
  );
}
